import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { mediaQuery, color } = baseVariables;

export const StyledQuickGroupInterstitial = styled.div`
  .qg-interstitial {
    border-radius: ${toRem(14)} ${toRem(14)} 0 0;

    .interstitial-body {
      max-height: 74dvh;

      .property-image {
        width: 100%;
        aspect-ratio: 3/2;
        object-fit: cover;
      }

      .pricing-row {
        flex-direction: column;

        .currency {
          color: ${color.neutral40};
        }
      }

      .add-to-rfp-cta {
        button {
          width: 100%;
        }
      }
    }

    .interstitial-footer {
      background-color: ${color.base20};
      border-top: none;
      padding: ${toRem(8)};
    }

    @media ${mediaQuery.md} {
      border-radius: ${toRem(14)};

      .interstitial-body {
        .property-image {
          aspect-ratio: 3/1;
        }

        .pricing-row {
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }

        .add-to-rfp-cta {
          display: flex;
          justify-content: flex-end;
          button {
            width: auto;
          }
        }
      }
    }
  }
`;

export const StyledDivider = styled.div`
  margin: ${toRem(24)} 0;
  border-top: ${toRem(1)} solid ${color.neutral30};
`;
